import React, { ReactElement } from "react";
import ProductOrderList from "../../components/Finance/ProductOrder";
import Layout from "../../components/layout";

const ProductOrderPage = (): ReactElement => {
  return (
    <Layout>
      <ProductOrderList />
    </Layout>
  );
};

export default ProductOrderPage;
